var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("Name")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.form.name,
            expression: "form.name",
            modifiers: { trim: true }
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.form.name },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.form, "name", $event.target.value.trim())
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      }),
      _vm._v(" "),
      _vm.errors.name
        ? _c("div", { staticClass: "text-danger" }, [
            _vm._v(_vm._s(_vm.errors.name[0]))
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("Type")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.type,
              expression: "form.type"
            }
          ],
          staticClass: "form-control",
          attrs: { disabled: _vm.disabledChangeType },
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.form,
                "type",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            }
          }
        },
        [
          _c("option", { attrs: { value: "parking" } }, [_vm._v("Parking")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "room" } }, [_vm._v("Room")])
        ]
      ),
      _vm._v(" "),
      _vm.errors.type
        ? _c("div", { staticClass: "text-danger" }, [
            _vm._v(_vm._s(_vm.errors.type[0]))
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", [_vm._v("Attribute Definitions")]),
        _vm._v(" "),
        _c("p", { staticClass: "help-block" }, [
          _vm._v(
            "Attribute keys and labels are free text. The key is sent to the integration; the label is shown on the location form."
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.form.attributes, function(attribute, index) {
          return _c(
            "div",
            { key: index, staticClass: "row margin-bottom-1x" },
            [
              _c("div", { staticClass: "col-sm-4" }, [
                _c("label", [_vm._v("Key")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: attribute.key,
                      expression: "attribute.key",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: attribute.key },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(attribute, "key", $event.target.value.trim())
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors["attributes." + index + ".key"]
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.errors["attributes." + index + ".key"][0]
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c("label", [_vm._v("Label")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: attribute.label,
                      expression: "attribute.label",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: attribute.label },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(attribute, "label", $event.target.value.trim())
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors["attributes." + index + ".label"]
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.errors["attributes." + index + ".label"][0]
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c("label", [_vm._v("Default value")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: attribute.default_value,
                      expression: "attribute.default_value",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: attribute.default_value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        attribute,
                        "default_value",
                        $event.target.value.trim()
                      )
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors["attributes." + index + ".default_value"]
                  ? _c("div", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.errors[
                              "attributes." + index + ".default_value"
                            ][0]
                          ) +
                          "\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-1" }, [
                _c("label", [_vm._v(" ")]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "a",
                    {
                      staticClass: "text-danger",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.removeAttribute(index)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-trash fa-lg" })]
                  )
                ])
              ])
            ]
          )
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-default btn-sm",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.addAttribute.apply(null, arguments)
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-plus" }),
            _vm._v("\n      Add Attribute\n    ")
          ]
        ),
        _vm._v(" "),
        _vm.errors.attributes
          ? _c("div", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.errors.attributes[0]))
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1769b688", { render: render, staticRenderFns: staticRenderFns })
  }
}